import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '@chakra-ui/react';
export const RichTextDisplay = (props) => {
    const fontSize = props.fontSize || 18;
    return (_jsx(Text, { ...props, css: {
            '& p': {
                fontSize,
                lineHeight: 'base',
                marginBottom: 2,
                minHeight: 2,
            },
            '& h1': {
                fontSize: fontSize + 4,
                marginTop: 2,
                marginBottom: 1,
                fontWeight: 500,
            },
            '& ul, & ol': {
                marginLeft: 6,
                listStyleType: 'disc',
                marginBottom: 2,
            },
            '& li': {
                fontSize,
                marginBottom: 1,
            },
            '& strong, & b': {
                fontWeight: 500,
            },
            '& em': {
                fontStyle: 'italic',
            },
            '& u': {
                textDecoration: 'underline',
            },
        }, dangerouslySetInnerHTML: {
            __html: props.htmlString,
        } }));
};
